<template>
    <div class="flex py-4 justify-center flex-1 max-w-screen-2xl w-screen md:px-8">
        <div class="flex flex-col rounded-lg gap-6 w-full h-full items-center ">
            <!-- Icon inside a  -->
            <div class="bg-primary-300 w-32 h-32 rounded-full flex items-center justify-center">
                <LinkVariantOff :size="48" class="text-white" />
            </div>
            <h1 class="text-2xl">
                {{ $t("testfleet.login.expired_link") }}
            </h1>
            <p class="text-center font-light w-2/3">
                {{ $t("testfleet.login.expired_link.description") }}
            </p>
            <Button variant="default" @click="$router.push('/login')"
                class="ps-4 pe-6 py-3 gap-2 text-nowrap text-sm flex items-center justify-center w-fit"
                :label="$t('testfleet.login.expired_link.button')" />
        </div>
    </div>
</template>

<script setup lang="ts">
import Button from '@/components/Button/Button.vue';
// @ts-ignore
import LinkVariantOff from 'vue-material-design-icons/LinkVariantOff.vue';
</script>
